import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICheckSession, TError } from 'entities/protected-route/types/check-auth-interface';
import { fetchCheckAuth } from 'entities/protected-route/action/fetch-check-auth';


const initialState: ICheckSession = {
    isValidSession: false,
    isLoading: false,
    error: [],
};

export const checkSession = createSlice({
    name: 'checkSession',
    initialState,
    reducers: {
        resetAuth: (state) => {
            state.isValidSession = false;
            state.isLoading = false;
            state.error = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCheckAuth.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchCheckAuth.fulfilled, (state, action: PayloadAction<{ answer: boolean }>) => {
                state.isValidSession = action.payload.answer;
                state.isLoading = false;
                state.error = [];
            })
            .addCase(fetchCheckAuth.rejected, (state, action) => {
                state.isValidSession = false;
                state.isLoading = false;
                state.error = action.payload as TError;
            });
    },
});

export const { resetAuth } = checkSession.actions;
export default checkSession.reducer;